import React from 'react';

import type { TableContext as TableContextType } from '@/components/ui/table/table.type';

export const TableContext = React.createContext<TableContextType>(
  {} as TableContextType
);

export const useTableContext = () => React.useContext(TableContext);
